import axios from "axios";
import { notification } from "@fle-ui/next";
import qs from 'qs'
import { mainHost1, DATA_CODE, mainHost5 } from "../config";
import { replaceParams } from './common';
import { handleGotoLogin } from '../utils/helpers';

export const httpClient = axios.create({
  baseURL: mainHost1,
  timeout: 60000
})

export const phpHttpClient = axios.create({
  baseURL: mainHost5,
  timeout: 60000
})


const requestOnFulFilled = config => {
  config.headers["authority_token"] = localStorage.getItem("token");
  // config.headers["authority_token"] = 'ekKz2zzpNksV4ycrXhsP256OGTQoJRUR-202108251344459870285163-10-1';

  config.url = replaceParams(config.url, '__date', new Date().getTime());

  return config;
}

const phpRequestOnFulFilled = config => {
  config.headers["authority-token"] = localStorage.getItem("token");
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  if(config.method != 'get'){
    config.data=qs.stringify(config.data);
  }
  // config.headers["manager-token"] = '7003cc172623f965bf606f0bda8769b0';
  // config.headers["authority_token"] = 'ekKz2zzpNksV4ycrXhsP256OGTQoJRUR-202108251344459870285163-10-1';

  config.url = replaceParams(config.url, '__date', new Date().getTime());

  return config;
}

const requestOnRejected = err => {
  notification.error({
    message: "发送请求失败",
    description: err
  });
  return false;
}
const responseOnFulFilled = res => {
  const { status, data, statusText, headers } = res;
  return new Promise((resolve, reject) => {
    if (status < 200 || status > 300) {
      notification.error({
        message: `请求错误: ${status}`,
        description: statusText
      });
    } else if (res.config.responseType === 'blob') {
      resolve({ data, headers, success: true });
      return;
    } else if (!data.success) {
      notification.error({
        message: "提示",
        description: data.message
      });
      if (String(data.code) === DATA_CODE.LOGIN_ERROR) {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        handleGotoLogin();
      }
      return reject(data)
    } else if (String(data.code) !== '2000') {
      notification.error({
        message: "提示",
        description: data.message
      });
      return reject(data)
    } else {
      return resolve(data || true);
    }
    return reject()
  })
}
const responseOnRejected = () => {
  notification.error({
    message: "提示",
    description: "系统错误"
  });
  return false
}


httpClient.interceptors.request.use(requestOnFulFilled, requestOnRejected);
httpClient.interceptors.response.use(responseOnFulFilled, responseOnRejected);
phpHttpClient.interceptors.request.use(phpRequestOnFulFilled, requestOnRejected);
phpHttpClient.interceptors.response.use(responseOnFulFilled, responseOnRejected);



